/* eslint-disable prettier/prettier */
import AOS from 'aos'
import 'aos/dist/aos.css'

AOS.init({
    // disable: 'mobile', // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
    once: true, // whether animation should happen only once - while scrolling down
})
